export function assertIsString(variable: any): asserts variable is string {
  if (typeof variable !== "string") {
    throw new Error(
      `Expected variable ${JSON.stringify(
        variable
      )} to be a string! It was instead ${typeof variable}`
    );
  }
}
